import { defaultProfilePicFileName, getProfilePicPath } from "../../constants/instructorConstants";
import { getApiUrl } from "../../constants/pathConstants"
import { communityStateData } from "../../data/communityStateData"
// import { socialData } from "../../data/socialData";
import { UserPost } from "../../types/posts";
import { API_END_POINT_CREATE_NEW_POST, API_END_POINT_GET_ALL_POSTS, API_END_POINT_GET_LIKES_FOR_USER, API_END_POINT_GET_POSTS_FOR_COMMUNITY, API_END_POINT_GET_POSTS_FOR_USER, API_END_POINT_LIKE_POST, API_END_POINT_UNLIKE_POST } from "../endPoints";
// import { UserDetails } from "../types";

type ServerPostData = {
	id: string
	post_str: string
	user_id: string
	community_id: string
	create_date: string
	post_img: string
	profile_pics: string
	name: string
	like_count: string
	comment_count?: string
	post_verified?: boolean
}

function NewPostFactory(post: ServerPostData): UserPost {
	return {
		postId: post.id,
		sourceUserId: post.user_id,
		sourceName: post.name ? post.name : 'Unknown', // `User ${post.user_id}`,
		community: communityStateData.communities[parseInt(post.community_id) - 1] ? communityStateData.communities[parseInt(post.community_id) - 1].community_name : `Unknown`,
		sourceImgSrc: post.profile_pics ? getProfilePicPath(post.profile_pics, 0) : getProfilePicPath(defaultProfilePicFileName, 0), // 'https://skivio.co/uploads/profile_pics/1756864061131-fileName.jpg',
		postDate: new Date(post.create_date).getTime(),
		postMsg: post.post_str,
		postImgSrc: post.post_img,
		verified: post.post_verified === true,
		community_id: post.community_id,
		likeCount: post.like_count,
		commentCount: post.comment_count
	}
}

class PostConnector {
	requestInProgress: boolean = false

	public async getUserPostsRequest(userId: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [PostConnector] getUserPostsRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				const urlParams = new URLSearchParams()
				urlParams.append("id", userId)
				urlParams.append("cache", `${Math.random()}`) // userId)

				let headers = new Headers();

				headers.append('Content-Type', 'application/json');
				headers.append('Accept', 'application/json');

				await fetch(`${getApiUrl()}${API_END_POINT_GET_POSTS_FOR_USER}?${urlParams}`, {
					method: 'GET',
					headers: headers
				})
					.then((res) => res.json())
					.then((data) => {
						// console.log(data)
						if (data.posts) {
							// communityStateData.userPosts = data.posts
							let newPosts: UserPost[] = []
							// let sourceUserIds: string[] = [] // store list of user ids from posts
							data.posts.forEach((post: ServerPostData) => {
							// 	{
							// 	post_str: string,
							// 	user_id: string
							// 	community_id: string
							// 	create_date: string
							// 	post_img: string
							// 	profile_pics: string
							// 	name: string
							// }) => {
								newPosts.push(NewPostFactory(post))
							});
							// load any user details for ids which are included in posts
							communityStateData.userPosts = newPosts.reverse()

						} else {
							// TODO: add error handling for searches which don't return values
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return true
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[PostConnector] - getUserPostsRequest() failed')
			console.log(err)
			return false
		}
	}

	public async getCommunityPostsRequest(communityId: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [PostConnector] getUserPostsRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				const urlParams = new URLSearchParams()
				urlParams.append("id", communityId)
				urlParams.append("cache", `${Math.random()}`) // userId)

				let headers = new Headers();

				headers.append('Content-Type', 'application/json');
				headers.append('Accept', 'application/json');

				await fetch(`${getApiUrl()}${API_END_POINT_GET_POSTS_FOR_COMMUNITY}?${urlParams}`, {
					method: 'GET',
					headers: headers
				})
					.then((res) => res.json())
					.then((data) => {
						// console.log(data)
						if (data.posts) {
							// communityStateData.userPosts = data.posts
							let newPosts: UserPost[] = []
							// let sourceUserIds: string[] = [] // store list of user ids from posts
							data.posts.forEach((post: ServerPostData) => {
							// 	post_str: string,
							// 	user_id: string
							// 	community_id: string
							// 	create_date: string
							// 	post_img: string
							// 	profile_pics: string
							// 	name: string
							// }) => {
								// newPosts.push({
								// 	postId: '1',
								// 	sourceUserId: post.user_id,
								// 	sourceName: post.name ? post.name : 'Unknown', // `User ${post.user_id}`,
								// 	community: communityStateData.communities[parseInt(post.community_id) - 1].community_name, // `Unknown`,
								// 	sourceImgSrc: post.profile_pics ? getProfilePicPath(post.profile_pics, 0) : getProfilePicPath(defaultProfilePicFileName, 0), // 'https://skivio.co/uploads/profile_pics/1756864061131-fileName.jpg',
								// 	postDate: new Date(post.create_date).getTime(),
								// 	postMsg: post.post_str,
								// 	postImgSrc: post.post_img,
								// 	verified: true,
								// 	community_id: post.community_id
								// })
								newPosts.push(NewPostFactory(post))
							});
							// load any user details for ids which are included in posts
							communityStateData.userPosts = newPosts.reverse()

						} else {
							// TODO: add error handling for searches which don't return values
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return true
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[PostConnector] - getUserPostsRequest() failed')
			console.log(err)
			return false
		}
	}

	// public async getUserPostsRequest(userId: string): Promise<boolean> {
	// 	try {
	// 		if (this.requestInProgress) {
	// 			console.log('WARNING - [PostConnector] getUserPostsRequest() called while request is in process')
	// 			return false
	// 		} else {
	// 			this.requestInProgress = true
	// 			const urlParams = new URLSearchParams()
	// 			urlParams.append("id", `${Math.random()}`) // userId)

	// 			let headers = new Headers();

	// 			headers.append('Content-Type', 'application/json');
	// 			headers.append('Accept', 'application/json');

	// 			await fetch(`${getApiUrl()}${API_END_POINT_GET_POSTS_FOR_USER}?${urlParams}`, {
	// 				method: 'GET',
	// 				headers: headers
	// 			})
	// 				.then((res) => res.json())
	// 				.then((data) => {
	// 					// console.log(data)
	// 					if (data.posts) {
	// 						// communityStateData.userPosts = data.posts
	// 						let newPosts: UserPost[] = []
	// 						// let sourceUserIds: string[] = [] // store list of user ids from posts
	// 						data.posts.forEach((post: {
	// 							post_str: string,
	// 							user_id: string
	// 							community_id: string
	// 							create_date: string
	// 							post_img: string
	// 						}) => {
	// 							// const userDetails: UserDetails | undefined = socialData.getUserDetails(post.user_id)
	// 							// if (userDetails == undefined) {
	// 							// 	const newUserDetails: 
	// 							// }

	// 							// if (!sourceUserIds.includes(post.user_id)) {
	// 							// 	sourceUserIds.push(post.user_id)
	// 							// }
	// 							newPosts.push({
	// 								postId: '1',
	// 								sourceUserId: post.user_id,
	// 								sourceName: '', // `User ${post.user_id}`,
	// 								community: `Community #${post.community_id}`,
	// 								sourceImgSrc: '', // 'https://skivio.co/uploads/profile_pics/1756864061131-fileName.jpg',
	// 								postDate: new Date(post.create_date).getTime(),
	// 								postMsg: post.post_str,
	// 								postImgSrc: post.post_img,
	// 								verified: true
	// 							})
	// 						});
	// 						// load any user details for ids which are included in posts
	// 						communityStateData.userPosts = newPosts

	// 					} else {
	// 						// TODO: add error handling for searches which don't return values
	// 					}
	// 				})
	// 				.catch((error) => {
	// 					console.log(error)
	// 				})
				
	// 			this.requestInProgress = false
	// 			return true
	// 		}
	// 		// return true
	// 	} catch(err) {
	// 		this.requestInProgress = false
	// 		console.log('[PostConnector] - getUserPostsRequest() failed')
	// 		console.log(err)
	// 		return false
	// 	}
	// }

	public async getAllPostsRequest(): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [PostConnector] getAllPostsRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				const urlParams = new URLSearchParams()
				urlParams.append("cache", `${Math.random()}`) // userId)

				let headers = new Headers();

				headers.append('Content-Type', 'application/json');
				headers.append('Accept', 'application/json');

				await fetch(`${getApiUrl()}${API_END_POINT_GET_ALL_POSTS}?${urlParams}`, {
					method: 'GET',
					headers: headers
				})
					.then((res) => res.json())
					.then((data) => {
						if (data.posts) {
							let newPosts: UserPost[] = []
							data.posts.forEach((post: ServerPostData) => {
								// newPosts.push({
								// 	postId: '1',
								// 	sourceUserId: post.user_id,
								// 	sourceName: post.name ? post.name : 'Unknown', // `User ${post.user_id}`,
								// 	community: communityStateData.communities[parseInt(post.community_id) - 1].community_name, // `Unknown`,
								// 	sourceImgSrc: post.profile_pics ? getProfilePicPath(post.profile_pics, 0) : getProfilePicPath(defaultProfilePicFileName, 0), // 'https://skivio.co/uploads/profile_pics/1756864061131-fileName.jpg',
								// 	postDate: new Date(post.create_date).getTime(),
								// 	postMsg: post.post_str,
								// 	postImgSrc: post.post_img,
								// 	verified: true,
								// 	community_id: post.community_id
								// })
								newPosts.push(NewPostFactory(post))
							});
							// load any user details for ids which are included in posts
							communityStateData.userPosts = newPosts.reverse()

						} else {
							// TODO: add error handling for searches which don't return values
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return true
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[PostConnector] - getInstructorProfileRequest() failed')
			console.log(err)
			return false
		}
	}

	public async getAllPostsForUserFeedRequest(userId: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [PostConnector] getAllPostsForUserRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				const urlParams = new URLSearchParams()
				urlParams.append("id", userId)
				urlParams.append("cache", `${Math.random()}`) // userId)

				let headers = new Headers();

				headers.append('Content-Type', 'application/json');
				headers.append('Accept', 'application/json');

				await fetch(`${getApiUrl()}${API_END_POINT_GET_POSTS_FOR_USER}?${urlParams}`, {
					method: 'GET',
					headers: headers
				})
					.then((res) => res.json())
					.then((data) => {
						if (data.posts) {
							let newPosts: UserPost[] = []
							data.posts.forEach((post: ServerPostData) => {
								// newPosts.push({
								// 	postId: '1',
								// 	sourceUserId: post.user_id,
								// 	sourceName: post.name ? post.name : 'Unknown', // `User ${post.user_id}`,
								// 	community: communityStateData.communities[parseInt(post.community_id) - 1].community_name, // `Unknown`,
								// 	sourceImgSrc: post.profile_pics ? getProfilePicPath(post.profile_pics, 0) : getProfilePicPath(defaultProfilePicFileName, 0), // 'https://skivio.co/uploads/profile_pics/1756864061131-fileName.jpg',
								// 	postDate: new Date(post.create_date).getTime(),
								// 	postMsg: post.post_str,
								// 	postImgSrc: post.post_img,
								// 	verified: true,
								// 	community_id: post.community_id
								// })
								newPosts.push(NewPostFactory(post))
							});
							// load any user details for ids which are included in posts
							communityStateData.userPosts = newPosts.reverse()

						} else {
							// TODO: add error handling for searches which don't return values
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return true
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[PostConnector] - getInstructorProfileRequest() failed')
			console.log(err)
			return false
		}
	}

	public async performCreatePostRequest(
		user_id: string,
		post_title: string | undefined,
		post_str: string,
		post_img: string | undefined,
		community_id: string
	):  Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [PostConnector] performCreatePostRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				let requestSuccess = false

				await fetch(`${getApiUrl()}${API_END_POINT_CREATE_NEW_POST}`,{
					method: 'post',
					headers: {'Content-Type':'application/json'},
					body: JSON.stringify({
						"user_id": user_id,
						"post_title": post_title,
						"post_str": post_str,
						"post_img": post_img,
						"community_id": community_id
					})
				})
					.then((res) => res.json())
					.then((data) => {
						if (data.status === 'success') {
							requestSuccess = true
						} else {
							requestSuccess = false
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return requestSuccess
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[PostConnector] - performCreatePostRequest() failed')
			console.log(err)
			return false
		}
	}

	public async getLikesForUserRequest(userId: string): Promise<string[]> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [PostConnector] getLikesForUserRequest() called while request is in process')
				this.requestInProgress = false
				return []
			} else {
				this.requestInProgress = true
				const urlParams = new URLSearchParams()
				urlParams.append("id", userId)
				urlParams.append("cache", `${Math.random()}`) // userId)

				let headers = new Headers();

				headers.append('Content-Type', 'application/json');
				headers.append('Accept', 'application/json');

				let likeData: string[] = []

				await fetch(`${getApiUrl()}${API_END_POINT_GET_LIKES_FOR_USER}?${urlParams}`, {
					method: 'GET',
					headers: headers
				})
					.then((res) => res.json())
					.then((data) => {
						if (data.likes) {
							likeData = data.likes as string[]
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return likeData
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[UserConnector] - getLikesForUserRequest() failed')
			console.log(err)
			return []
		}
	}

	public async likePostRequest(post_id: string, user_id: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [PostConnector] LikePostRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				let requestSuccess = false

				await fetch(`${getApiUrl()}${API_END_POINT_LIKE_POST}?cache=${Math.floor(Math.random() * 1000)}`,{
					method: 'post',
					headers: {'Content-Type':'application/json'},
					body: JSON.stringify({
						"post_id": post_id,
						"user_id": user_id
					})
				})
					.then((res) => res.json())
					.then((data) => {
						if (data.status === 'success') {
							requestSuccess = true
						} else {
							requestSuccess = false
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return requestSuccess
			}
		} catch(err) {
			this.requestInProgress = false
			console.log('[PostConnector] - LikePostRequest() failed')
			console.log(err)
			return false
		}
	}

	public async unlikePostRequest(post_id: string, user_id: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [PostConnector] unlikePostRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				let requestSuccess = false

				await fetch(`${getApiUrl()}${API_END_POINT_UNLIKE_POST}?cache=${Math.floor(Math.random() * 1000)}`,{
					method: 'post',
					headers: {'Content-Type':'application/json'},
					body: JSON.stringify({
						"post_id": post_id,
						"user_id": user_id
					})
				})
					.then((res) => res.json())
					.then((data) => {
						if (data.status === 'success') {
							requestSuccess = true
						} else {
							requestSuccess = false
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return requestSuccess
			}
		} catch(err) {
			this.requestInProgress = false
			console.log('[PostConnector] - unlikePostRequest() failed')
			console.log(err)
			return false
		}
	}
}

export const postConnector: PostConnector = new PostConnector()